'use client';

/* eslint-disable import/no-duplicates */
import { useCallback } from 'react';
import { isAvailableLocale } from '@ianesthesie-kit/config';
import { format, isValid, parse } from 'date-fns';
import enLocale from 'date-fns/locale/en-US';
import frLocale from 'date-fns/locale/fr';
import { isTimestamp, useLocale } from '@ianesthesie-kit/core';

const locMap = {
  en: enLocale,
  fr: frLocale,
  es: enLocale // TODO remove es from AvailableLocales in doctor dashboard (maybe remove available locales from kit and have it declared per project)
};

export const useDateFormatter = () => {
  const locale = useLocale();

  return useCallback(
    (
      str: string | Date | null | undefined,
      outFormat = 'P',
      inFormat = 'yyyy-MM-dd'
    ): string | undefined => {
      if (!str) {
        return undefined;
      }

      if (!isAvailableLocale(locale)) {
        return str.toLocaleString();
      }

      const date =
        typeof str === 'string'
          ? isTimestamp(str)
            ? new Date(str)
            : parse(str, inFormat, Date.now())
          : str;
      if (!isValid(date)) {
        return str.toLocaleString();
      }

      return format(date, outFormat, { locale: locMap[locale] });
    },
    [locale]
  );
};
